import {
    Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/ScrollReveal";
import { CURSUS_FAQ } from "@/lib/cursusMeta";

export default function CursusFAQ({ slug }) {
    const items = CURSUS_FAQ[slug] || [];
    return (
        <section
            className="relative overflow-hidden bg-brand-ink py-24 text-white md:py-32"
            data-testid="cursus-faq"
        >
            <div className="absolute inset-0 grain pointer-events-none opacity-20" />
            <div className="relative mx-auto max-w-5xl px-6">
                <Reveal>
                    <span className="text-[11px] font-semibold uppercase tracking-[0.32em] text-brand-orange">
                        Questions fréquentes
                    </span>
                    <h2 className="mt-5 max-w-3xl font-display font-normal leading-[0.95] tracking-tightest text-[40px] sm:text-5xl lg:text-[64px]">
                        Les questions <em className="italic text-white/55">qu'on nous pose.</em>
                    </h2>
                </Reveal>

                <div className="mt-16">
                    <Accordion type="single" collapsible className="space-y-3">
                        {items.map((qa, i) => (
                            <AccordionItem
                                key={qa.q}
                                value={`item-${i}`}
                                className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-1 data-[state=open]:border-brand-orange/40"
                                data-testid={`faq-item-${i + 1}`}
                            >
                                <AccordionTrigger className="py-5 text-left text-base font-semibold text-white hover:text-brand-orange hover:no-underline md:text-lg">
                                    {qa.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-sm leading-relaxed text-white/70 md:text-base">
                                    {qa.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
